import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PromoCodeService {

  constructor(
    private _http: HttpClient
  ) { }

  // START THE SERVER json-server --watch promo-code.db.json

  getAllPromoCodes(): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this._http.get(`${environment.apiUrl}/coupon`).subscribe((response: any) => {
        resolve(response);
        return response;
      }, reject);
    });
  }

  addNewPromoCode(post: any): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this._http.post(`${environment.apiUrl}/coupon`, post).subscribe((response: any) => {
        resolve(response);
        return response;
      }, reject);
    });
  }

  updatePromoCode(post: any): Promise<any[]> {
    
    return new Promise((resolve, reject) => {
      this._http.patch(`${environment.apiUrl}/coupon/${post.public_id}`, post).subscribe((response: any) => {
        resolve(response);
        return response;
      }, reject);
    });
  }
}
